import { render, staticRenderFns } from "./PageMemberConnected.vue?vue&type=template&id=097398d8"
import script from "./PageMemberConnected.vue?vue&type=script&lang=js"
export * from "./PageMemberConnected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports